export default "__VITE_ASSET__DtA1qtkT__"